// Check if `flatMap` is supported natively
if (!Array.prototype.flatMap) {
  // Polyfill for `flatMap`
  Array.prototype.flatMap = function(callback) {
    return Array.prototype.concat.apply([], this.map(callback));
  };
}
